import { DEFAULT_PAGE_SIZE } from "@/utils/pageSize.mjs";

export default {
  computed: {
    pageSize() {
      return this.$store?.getters?.pageSize || DEFAULT_PAGE_SIZE;
    },
  },
  methods: {
    handlePageSizeChange() {
      if ("pageNum" in this) {
        this.pageNum = 1;
      }
      if (this.query && Object.prototype.hasOwnProperty.call(this.query, "page")) {
        this.query.page = 1;
      }
      if (typeof this.information === "function") {
        return this.information(1);
      }
      if (typeof this.loadList === "function") {
        return this.loadList(1);
      }
      return undefined;
    },
  },
};
